"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileTagObjectImage = exports.VideoFrameTagObjectImage = exports.AnimalTagObject = exports.LocationTagObject = exports.ObjectTagObject = exports.VehicleTagObject = exports.GroupTagObject = exports.PersonTagObject = exports.VehicleTagObjectTypes = exports.TagObjectTypes = exports.TagObjectCommon = void 0;
class TagObjectCommon {
}
exports.TagObjectCommon = TagObjectCommon;
exports.TagObjectTypes = ["person", "vehicle", "object", "location", "group", "animal"];
exports.VehicleTagObjectTypes = ["car", "hgv", "publictrans", "motorcycle", "bicycle", "other"];
class PersonTagObject extends TagObjectCommon {
}
exports.PersonTagObject = PersonTagObject;
class GroupTagObject extends TagObjectCommon {
}
exports.GroupTagObject = GroupTagObject;
class VehicleTagObject extends TagObjectCommon {
}
exports.VehicleTagObject = VehicleTagObject;
class ObjectTagObject extends TagObjectCommon {
}
exports.ObjectTagObject = ObjectTagObject;
class LocationTagObject extends TagObjectCommon {
}
exports.LocationTagObject = LocationTagObject;
class AnimalTagObject extends TagObjectCommon {
}
exports.AnimalTagObject = AnimalTagObject;
class VideoFrameTagObjectImage {
}
exports.VideoFrameTagObjectImage = VideoFrameTagObjectImage;
class FileTagObjectImage {
}
exports.FileTagObjectImage = FileTagObjectImage;
